import { styled } from '@ori-ui/mui';
export var ShadesRoot = styled('div')(function (_ref) {
  var theme = _ref.theme;
  return {
    alignItems: 'center',
    display: 'flex',
    gap: theme.spacing(1),
    height: 14,
    overflow: 'hidden'
  };
});
export var HiddenShadesCount = styled('div')(function (_ref2) {
  var theme = _ref2.theme;
  return {
    color: theme.palette.text.primary,
    fontSize: theme.typography.pxToRem(10),
    fontWeight: theme.typography.fontWeightBold
  };
});
//# sourceMappingURL=styles.js.map